import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CarieraService } from './cariera.service';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-cariera',
    templateUrl: './cariera.component.html',
    styleUrls: ['./cariera.component.scss']
})
export class CarieraComponent implements OnInit {
    public portalLive = environment.portalLive;
    institution!: string;
    documente!: any[];

    isLoading = false;
    helper = helper;

    // Browserele din aplicații (Facebook, Instagram, Messenger) nu pot deschide fișiere blob în tab nou
    isInAppBrowser = /FBAN|FBAV|FB_IAB|FBIOS|Instagram|Messenger/i.test(navigator.userAgent);

    constructor(
        private route: ActivatedRoute,
        private carieraService: CarieraService
    ) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.institution = params.get('institution')!;
            this.getDocumenteForInstitution(this.institution);
        });
    }

    getDocumenteForInstitution(institution: string) {
        this.isLoading = true;
        this.carieraService.getDocumente(institution)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (result: any) => {
                    this.documente = result.data;
                    console.log('Documente', this.documente);
                },
                error: (error) => {
                    console.error('Error fetching documente', error);
                }
            });
    }

    getAllDocuments(documents: any): any[] {
        if (!documents) return [];
        return Object.values(documents).flat();
    }

    // Link direct către endpoint-ul public: funcționează și în browserele din aplicații (Facebook etc.)
    getFileUrl(id: number): string {
        return this.carieraService.fileDownloadUrl + id;
    }
}
